import React from 'react'
import { Link } from 'react-router-dom'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
import { all_routes } from '../../../router/all_routes'

const Latestblog = () => {
    const route = all_routes
    return (
        <>
            {/* Latest Blogs */}
            <section className="blogs-section-five bg-white">
                <div className="container">
                    <div
                        className="section-header section-header-six text-center"
                        data-aos="fade-down"
                    >
                        <h2>Take the First Step</h2>
                    </div>
                    <div className="home-five-blog">
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="blog-card">
                                    <div className="blog-img">
                                        <ImageWithBasePath
                                            src="assets/img/home-1/blog-05.jpg"
                                            alt="img"
                                            className="img-fluid"
                                        />
                                    </div>
                                    <div className="blog-content">
                                        <h5>
                                            Student
                                        </h5>
                                        <p style={{ overflow: 'visible', display: 'block', WebkitLineClamp: 'unset', whiteSpace: 'normal' }}>
                                            Dreaming of studying in Canada, the US, the UK, Ireland, Australia, or Germany? Register now and ignite your global education journey!
                                        </p>
                                        <div className="text-center">
                                            <Link to={route.register} className="btn btn-xl btn-primary mt-3">
                                                Sign Up for Free
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="blog-card">
                                    <div className="blog-img">
                                        <ImageWithBasePath
                                            src="assets/img/home-1/blog-02.jpg"
                                            alt="img"
                                            className="img-fluid"
                                        />
                                    </div>
                                    <div className="blog-content">
                                        <h5>
                                            Recruitment Partner
                                        </h5>
                                        <p style={{ overflow: 'visible', display: 'block', WebkitLineClamp: 'unset', whiteSpace: 'normal' }}>
                                            Support international students? Join our global partner network and transform the way you recruit!
                                        </p>
                                        <div className="text-center">
                                            <Link to={route.recruiterHome} className="btn btn-xl btn-primary mt-3">
                                                Become a Recruitment Partner
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="blog-card">
                                    <div className="blog-img">
                                        <ImageWithBasePath
                                            src="assets/img/home-1/blog-01.jpg"
                                            alt="img"
                                            className="img-fluid"
                                        />
                                    </div>
                                    <div className="blog-content">
                                        <h5>
                                            Partner School
                                        </h5>
                                        <p style={{ overflow: 'visible', display: 'block', WebkitLineClamp: 'unset', whiteSpace: 'normal' }}>
                                            Join 1,500+ top institutions worldwide! Complete our contact form and our Partner Relations team will connect with you shortly.
                                        </p>
                                        <div className="text-center">
                                            <Link to={route.institutionHome} className="btn btn-xl btn-primary mt-3">
                                                Become a Partner Institution
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Latest Blogs */}
        </>

    )
}

export default Latestblog
